
import { BlogArticlesMap } from '@/types/BlogArticle';
import { article as kiVideomarketing } from './ki-videomarketing-revolution-schweiz-2025';
import { article as aiErklaervideos } from './5-vorteile-ai-erklaervideos-unternehmen';
import { article as videomarketing2025 } from './videomarketing-trends-2025';
import { article as aiVsKlassisch } from './ai-vs-klassische-videoproduktion-kostenvergleich';
import { article as kiMyths } from './ki-videoproduktion-mythen';
import { article as kiStorytelling } from './ki-storytelling-videos-veraendert';
import { article as ecommerceVideo } from './videomarketing-ecommerce-ki-produktvideos';
import { article as contentMitKi } from './content-mit-ki-skalieren';
import { article as kiSocialMedia } from './ki-social-media-video-content';
import { article as kiVideoKosten } from './ki-video-kosten-nutzen-erklaert';
import { article as kiVideoIndividuell } from './ki-video-individuell-markenkonform';

// Create a map of all blog articles
export const blogArticles: BlogArticlesMap = {
  "ki-videomarketing-revolution-schweiz-2025": kiVideomarketing,
  "5-vorteile-ai-erklaervideos-unternehmen": aiErklaervideos,
  "videomarketing-trends-2025": videomarketing2025,
  "ai-vs-klassische-videoproduktion-kostenvergleich": aiVsKlassisch,
  "ki-videoproduktion-mythen": kiMyths,
  "ki-storytelling-videos-veraendert": kiStorytelling,
  "videomarketing-ecommerce-ki-produktvideos": ecommerceVideo,
  "content-mit-ki-skalieren": contentMitKi,
  "ki-social-media-video-content": kiSocialMedia,
  "ki-video-kosten-nutzen-erklaert": kiVideoKosten,
  "ki-video-individuell-markenkonform": kiVideoIndividuell,
};

// Helper function to get all articles as an array
export const getAllArticles = () => {
  return Object.values(blogArticles);
};

// Helper function to get recent articles
export const getRecentArticles = (count: number = 3) => {
  return getAllArticles()
    .sort((a, b) => {
      const dateA = new Date(a.date.split('.').reverse().join('-'));
      const dateB = new Date(b.date.split('.').reverse().join('-'));
      return dateB.getTime() - dateA.getTime();
    })
    .slice(0, count);
};

// Helper function to get article by slug
export const getArticleBySlug = (slug: string) => {
  return blogArticles[slug];
};
